import React from 'react';
import {connect} from "react-redux";
import {toast, ToastContainer} from "react-toastify";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import ReactPaginate from "react-paginate";
import Ax from "../../components/hoc/Ax";
import tapIcon from "../../services/TapIcon"
import Loader from "../../components/ui/Loader/Loader";
import TapSelect from "../../components/ui/TapSelect";
import {Modal} from "bootstrap";
import swal from "sweetalert";
import { Helmet } from 'react-helmet';
import TapApiUrls, { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import { DisplayListPagination } from '../../components/TapUi';
import { Link } from 'react-router-dom';
import AppBaseComponent from '../../components/AppBaseComponent';
import TapIcon from '../../services/TapIcon';

class ReportPermission extends AppBaseComponent {
  
    constructor(props) {
        super(props);
        this.initPermissionForm     =   {
            role_id                 :   props.roleData ? props.roleData.id : '',
            view_report_ids         :   [],
            download_report_ids     :   []
        }
        
        this.state                  =   {
            listing_loading         :   false,
            reportList              :   [],
            addReportVisibiltyForm  :   {...this.initPermissionForm},
            allSelected: false,
            allDownloadSelected: false
        }

        this.report_url         =   ORG_API_BASE_URL_2 + '/reports';
        this.add_permission_url =   ORG_API_BASE_URL_2 + '/add_reports_permission';
        this.role_report_permission_url =   ORG_API_BASE_URL_2 + '/reports_permission';
   }

   componentDidMount() {
        this.initilaizeData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.roleData !== this.props.roleData) {
            this.initilaizeData(nextProps);
        }
    }

    initilaizeData = (pr) => {
        if (pr && pr.roleData) {
            this.getReportList();
            this.roleReportPermission(pr);
        }
    }
   
    roleReportPermission =  (pr) => {
        HttpAPICall.withAthorization('GET',  this.role_report_permission_url + '/' + pr.roleData.id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data.data;
            this.setState({
                addReportVisibiltyForm  :   {
                    role_id             :   this.props.roleData.id,
                    view_report_ids     :   respData && respData.view_report_ids ? respData.view_report_ids : [],
                    download_report_ids :   respData && respData.download_report_ids ? respData.download_report_ids : []
                }
            })
        });
    }

    getReportList   =   ()    =>  {
        this.setState({listing_loading: true});
        HttpAPICall.withAthorization('GET',  this.report_url, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                reportList : respData && respData.length > 0 ? respData : [],
            })
        }).then(() => this.setState({listing_loading: false}));
    }

    handleDownloadSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        const allDownloadableIds = this.state.reportList
            .filter(report => this.state.addReportVisibiltyForm.view_report_ids.includes(report.id))
            .map(report => report.id);

        this.setState({
            allDownloadSelected: isChecked,
            addReportVisibiltyForm: {
                ...this.state.addReportVisibiltyForm,
                download_report_ids: isChecked ? allDownloadableIds : []
            }
        });
    };

    handleSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        const allReportIds = this.state.reportList.map(report => report.id);
    
        this.setState({
            allSelected: isChecked,
            addReportVisibiltyForm: {
                ...this.state.addReportVisibiltyForm,
                view_report_ids: isChecked ? allReportIds : [], 
            }
        });
    };
    
    handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        const value = parseInt(e.target.value);
        const { view_report_ids, download_report_ids } = this.state.addReportVisibiltyForm;
    
        let updatedViewReportIds = [...view_report_ids];
        let updatedDownloadReportIds = [...download_report_ids];
    
        if (e.target.name === 'view_report_ids') {
            if (isChecked) {
                updatedViewReportIds.push(value);
            } else {
                updatedViewReportIds = updatedViewReportIds.filter(val => val !== value);
            }
        } else if (e.target.name === 'download_report_ids') {
            if (isChecked) {
                updatedDownloadReportIds.push(value);
            } else {
                updatedDownloadReportIds = updatedDownloadReportIds.filter(val => val !== value);
            }
        }
    
        this.setState({
            addReportVisibiltyForm: {
                ...this.state.addReportVisibiltyForm,
                view_report_ids: updatedViewReportIds,
                download_report_ids: updatedDownloadReportIds
            },
            allSelected: updatedViewReportIds.length === this.state.reportList.length 
        });
    };

      saveReportRoleVisibiltyForm     =       (e)     =>      {
        e.preventDefault();
        
        this.setState({ saveFormSubmitting: true })
        HttpAPICall.withAthorization('PUT', this.add_permission_url, this.props.access_token, {}, { ...this.state.addReportVisibiltyForm }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.setState({ addReportVisibiltyForm     :        {...this.initPermissionForm}});
            this.roleReportPermission(this.props);
        }).then(() => this.setState({ saveFormSubmitting: false }));
    }

    render() {
       let {reportList}     =   this.state;
        return (<Ax>
            <Helmet><title>Role - Report Permission</title></Helmet>
            {this.state.listing_loading ? <div className='text-center'><Loader /></div>
                : 
                <>
                    <form onSubmit={this.saveReportRoleVisibiltyForm}>

                        <table className="table table-hover table-bordered my-4 table-sm">
                            <thead className="table-secondary">
                                <tr>
                                    <th style={{width: "20%"}}>Section</th>
                                    <th scope="col" style={{ width: "40%" }}>Reports</th>
                                    <th style={{ width: "20%" }} className='text-center'>View
                                        <div className='mt-1 d-flex align-items-center justify-content-center gap-2'>
                                        <input
                                                    type='checkbox'
                                                    name='all_select'
                                                    checked={this.state.allSelected}
                                                    onChange={this.handleSelectAllChange}
                                                />
                                            Select All
                                        </div>
                                    </th>
                                    <th style={{ width: "20%" }} className='text-center'>Download
                                    <div className='mt-1 d-flex align-items-center justify-content-center gap-2'>
                                                <input
                                                    type='checkbox'
                                                    name='all_download_select'
                                                    checked={this.state.allDownloadSelected}
                                                    onChange={this.handleDownloadSelectAllChange}
                                                />
                                                Select All
                                            </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                reportList.length > 0 
                                ? reportList.map((data, i) => {
                                    return (
                                        <tr>
                                            <td>{data.section}</td>
                                            <td>{data.name}</td>
                                            <td className='text-center'>
                                                <input
                                                    type='checkbox'
                                                    value={data.id}
                                                    name='view_report_ids'
                                                    onChange={this.handleCheckboxChange}
                                                    checked={this.state.addReportVisibiltyForm.view_report_ids.includes(data.id)}
                                                />
                                            </td>
                                            <td className='text-center'>
                                                <input
                                                    type='checkbox'
                                                    value={data.id}
                                                    name='download_report_ids'
                                                    disabled={!this.state.addReportVisibiltyForm.view_report_ids.includes(data.id)}
                                                    onChange={this.handleCheckboxChange}
                                                    checked={this.state.addReportVisibiltyForm.download_report_ids.includes(data.id)}
                                                />
                                            </td>
                                        </tr>
                                    )})
                                : <tr><td className='text-center' colSpan={4}>No Record Found</td></tr>
                            }
                                
                            </tbody>
                        </table>
                        <div className="float-end">
                        {
                            reportList.length > 0 &&
                            <button type="submit" disabled={this.state.saveFormSubmitting ? true : false} className="btn btn-primary mb-2">
                                Save  {this.state.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        }
                        </div>
                    </form>
                </>
            }
        </Ax>)
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        permissions             :   state.app.acl_info.permissions,
        group_permission        :   state.app.acl_info
    };
};


export default connect(mapStateToProps)(ReportPermission);